export const REGISTRATION_SUCCESS = 'online/REGISTRATION_SUCCESS';
export const LOGIN_SUCCESS = 'online/LOGIN_SUCCESS';
export const LINK_ACCOUNTS_SUCCESS = 'online/LINK_ACCOUNTS_SUCCESS';
export const LINK_ACCOUNTS_FAILURE = 'online/LINK_ACCOUNTS_FAILURE';

export const registrationSuccess = () => ({
  type: REGISTRATION_SUCCESS
});

export const loginSuccess = (casTicket) => ({
  type: LOGIN_SUCCESS,
  casTicket
});

export const linkAccountSuccess = () => ({
  type: LINK_ACCOUNTS_SUCCESS
});

export const linkAccountFailure = (error) => ({
  type: LINK_ACCOUNTS_FAILURE,
  reason: error
});
